import React, { useState } from "react";
import { MdLockOutline } from "react-icons/md";
import {getPincodeService }from"../services/apiService"
// Use a direct fetch call to the API so this check works without auth headers
// const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "http://192.168.0.165:8000";

const PincodeChecker = () => {
  const [pincode, setPincode] = useState("");
  const [deliveryText, setDeliveryText] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
const handleCheck = async () => {
  setError("");
  setDeliveryText("");

  if (!/^[0-9]{6}$/.test(pincode)) {
    setError("Please enter a valid 6-digit pincode");
    return;
  }

  try {
    setLoading(true);

    const res = await getPincodeService(pincode);

    console.log("FULL PINCODE RESPONSE:", res);

    // Handles both axios response and response.data
    const data = res?.data ?? res;

    console.log("PINCODE DATA:", data);

    const postalCode = data?.delivery_codes?.[0]?.postal_code;

    console.log("POSTAL CODE:", postalCode);
    console.log("CITY:", postalCode?.city);

    if (postalCode?.city) {
      setDeliveryText(`${postalCode.city} City is Serviceable`);
      setError("");
    } else {
      setError("Delivery not available for this pincode");
    }
  } catch (err) {
    console.error("Pincode check error:", err);
    setError("Failed to check delivery availability");
  } finally {
    setLoading(false);
  }
};

  return (
    <div style={styles.container}>
      <div style={styles.inputWrapper}>
        <input
          type="text"
          placeholder="Enter Delivery Pincode"
          value={pincode}
          maxLength={6}
          onChange={(e) => setPincode(e.target.value.replace(/[^0-9]/g, ""))}
          style={styles.input}
        />

        <button onClick={handleCheck} style={styles.button} disabled={loading}>
          {loading ? "CHECKING..." : "CHECK"}
        </button>
      </div>

      <p style={styles.secure}>
        <MdLockOutline color="#005487" size={16} />
        <span>Secure Transaction</span>
      </p>

      {deliveryText && <p style={styles.success}>{deliveryText}</p>}

      {error && <p style={styles.error}>{error}</p>}
    </div>
  );
};

export default PincodeChecker;

const styles = {
  container: {
    marginTop: "15px",
    maxWidth: "400px",
  },

  inputWrapper: {
    display: "flex",
    border: "1px solid #ddd",
    borderRadius: "4px",
    overflow: "hidden",
  },

  input: {
    flex: 1,
    padding: "10px",
    border: "none",
    outline: "none",
    fontSize: "15px",
  },

  button: {
    backgroundColor: "#005487",
    color: "#fff",
    border: "none",
    padding: "0 18px",
    fontWeight: "600",
    cursor: "pointer",
  },

  success: {
    marginTop: "8px",
    fontSize: "14px",
    fontWeight: "500",
    color: "#005487",
  },

  secure: {
    marginTop: "4px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "6px",
    fontSize: "14px",
    color: "#555",
  },

  error: {
    marginTop: "6px",
    fontSize: "13px",
    color: "red",
  },
};
